import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IKehoachNam } from "../../../model/respone/ke-hoach/IKehoachNam";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eKeHoachNamActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IKehoachNam[],
  LOAD_ERRR: "",
  SHOW_EDIT_MODAL: {} as IKehoachNam | undefined,
  CLOSE_EDIT_MODAL: undefined,

  SAVE_START: {} as IKehoachNam,
  SAVE_SUCCESS: {} as IKehoachNam,
  SAVE_ERROR: "",

  DELETE_START: {} as IIdsRequest,
  DELETE_SUCCESS: undefined,
  DELETE_ERROR: "",

  CHANGE_SELECTED_IDS: {} as number[]
};
export const eKeHoachNamActionIds = generateActionTypeIds(
  eKeHoachNamActionsObj,
  "KE_HOACH_NAM"
);
export type IKeHoachNamActionTypes = IGenericActionType<
  typeof eKeHoachNamActionsObj,
  "KE_HOACH_NAM"
>;
